import { useEffect, useState } from "react";
import { Settings } from "lucide-react";
import { PermissionMatrix } from "@/admin/PermissionMatrix";
import { FeeSettings } from "@/admin/FeeSettings";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { AdminTitle } from "@/admin/AdminLayout";
import { api, errMsg, useApi } from "@/lib/api";

const FIELDS = [
  ["bank_name", "Nama Bank Rekening CU", "Contoh: Bank Kalbar"],
  ["account_no", "Nomor Rekening CU", ""],
  ["account_name", "Atas Nama Rekening", ""],
  ["qris_image_url", "URL Gambar QRIS", "https://..."],
  ["office_phone", "No. Telepon Kantor", ""],
  ["loan_rate", "Bunga Pinjaman (% per bulan, flat)", "1.5"],
];

export default function AdminSettings() {
  const { data } = useApi("/settings");
  const [f, setF] = useState(null);
  useEffect(() => { if (data) setF(data); }, [data]);
  if (!f) return null;

  const save = async () => {
    try {
      await api.put("/admin/settings", { ...f, loan_rate: Number(f.loan_rate) });
      toast.success("Pengaturan disimpan");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div>
      <AdminTitle icon={Settings} title="Pengaturan" sub="Info rekening & QRIS yang ditampilkan saat anggota membayar" />
      <div className="bg-white rounded-2xl border border-slate-200 p-5 max-w-xl space-y-4">
        {FIELDS.map(([k, l, p]) => (
          <div key={k}>
            <label className="text-sm font-semibold">{l}</label>
            <Input data-testid={`settings-${k}`} className="mt-1" placeholder={p} value={f[k] ?? ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} />
          </div>
        ))}
        <button onClick={save} data-testid="settings-save-button" className="bg-red-600 hover:bg-red-700 text-white font-semibold px-6 py-2.5 rounded-lg">Simpan Pengaturan</button>
      </div>
      <PermissionMatrix />
      <FeeSettings />
    </div>
  );
}
